import React from 'react';
import Layout from 'layout/Layout';
import DisplayProduct from './DisplayProduct';

const Product = () => {
    return (
        <>
            <Layout title="Manage Products" tagline="orgranize your products with ease">
                <DisplayProduct />
            </Layout>
        </>
    );
};

export default Product;
